module.exports = __webpack_public_path__ + "static/media/London-sunset.07489310.svg";